import styled from "styled-components";

export const ContainerTitle = styled.div`
  margin-bottom: 22px;
`;
